export default __webpack_public_path__ + "static/media/experience.1061ddce.webp";